module.exports = __webpack_public_path__ + "img/1.5fff197b.jpg";